// FILENAME: frontend/src/pages/wip/WipWireframeTemplatePage.jsx
import React from 'react';
import { Box, Button, Chip, Divider, Paper, Stack, Typography } from '@mui/material';

const mockMetrics = [
  { label: 'Active dealers', value: '214' },
  { label: 'Programs running', value: '12' },
  { label: 'Alerts last 24h', value: '38' },
  { label: 'Avg response', value: '6m' },
];

const mockRows = [
  { id: 'A-4319', program: 'GMX Enrollment', status: 'Needs review', owner: 'Morgan R.' },
  { id: 'B-2088', program: 'Dealer Follow-up', status: 'Queued', owner: 'Riley J.' },
  { id: 'C-1192', program: 'Warranty Push', status: 'In progress', owner: 'Chris M.' },
];

const WipWireframeTemplatePage = () => {
  return (
    <Box sx={{ maxWidth: 1100, mx: 'auto', py: { xs: 2, sm: 3 } }}>
      <Stack spacing={3}>
        <Box>
          <Chip label="Wireframe" size="small" color="info" sx={{ mb: 1 }} />
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            Enrollment Health Snapshot
          </Typography>
          <Typography sx={{ color: 'text.secondary', mt: 1 }}>
            Replace this copy with the problem statement or goal for the page.
          </Typography>
        </Box>

        <Paper variant="outlined" sx={{ p: 2.5 }}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ alignItems: { sm: 'center' }, justifyContent: 'space-between' }}>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                Primary action
              </Typography>
              <Typography sx={{ color: 'text.secondary' }}>Describe the main workflow to support here.</Typography>
            </Box>
            <Stack direction="row" spacing={1}>
              <Button variant="contained">Start action</Button>
              <Button variant="outlined">Secondary</Button>
            </Stack>
          </Stack>
        </Paper>

        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
          {mockMetrics.map((metric) => (
            <Paper key={metric.label} variant="outlined" sx={{ p: 2, flex: 1 }}>
              <Typography variant="overline" sx={{ color: 'text.secondary' }}>
                {metric.label}
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 700 }}>
                {metric.value}
              </Typography>
            </Paper>
          ))}
        </Stack>

        <Paper variant="outlined" sx={{ p: 2.5 }}>
          <Stack spacing={2}>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                Trend view
              </Typography>
              <Typography sx={{ color: 'text.secondary' }}>
                Placeholder for charts or timeline content.
              </Typography>
            </Box>
            <Box
              sx={{
                height: 220,
                borderRadius: 2,
                border: '1px dashed',
                borderColor: 'divider',
                bgcolor: 'action.hover',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'text.secondary',
                fontSize: 14,
              }}
            >
              Chart area
            </Box>
          </Stack>
        </Paper>

        <Paper variant="outlined" sx={{ p: 2.5 }}>
          <Stack spacing={2}>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                Work queue
              </Typography>
              <Typography sx={{ color: 'text.secondary' }}>
                Mock table for the core list or dataset.
              </Typography>
            </Box>
            <Divider />
            <Stack spacing={1.5}>
              {mockRows.map((row) => (
                <Box key={row.id} sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
                  <Box>
                    <Typography sx={{ fontWeight: 600 }}>{row.program}</Typography>
                    <Typography sx={{ color: 'text.secondary', fontSize: 14 }}>{row.id}</Typography>
                  </Box>
                  <Box sx={{ textAlign: 'right' }}>
                    <Typography sx={{ fontWeight: 600 }}>{row.status}</Typography>
                    <Typography sx={{ color: 'text.secondary', fontSize: 14 }}>{row.owner}</Typography>
                  </Box>
                </Box>
              ))}
            </Stack>
          </Stack>
        </Paper>
      </Stack>
    </Box>
  );
};

export default WipWireframeTemplatePage;
